export default {
    REDUCER_KEY: "REGISTRATION_DOCUMENT",
    ENTITY_NAME: "rentRegistrationDocument",
    RESOURCE: "rent-registration-documents",
};
